import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrganisationProjects = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 36,
	height: 38,
	viewBox: "0 0 36 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Organisation page",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M34.7782 18.1914L34.4818 17.784C33.9632 17.1542 33.352 16.6541 32.6482 16.2837C31.7036 15.7466 30.6293 15.4688 29.518 15.4688H6.45852C5.34722 15.4688 4.29148 15.7466 3.32835 16.2837C2.606 16.6727 1.95774 17.2098 1.42061 17.8766C0.364867 19.2287 -0.13522 20.8956 0.031476 22.5626L0.716781 31.2122C0.957563 33.8238 1.27243 37.0466 7.14383 37.0466H28.8512C34.7226 37.0466 35.019 33.8238 35.2783 31.1937L35.9636 22.5811C36.1303 21.0253 35.7228 19.4694 34.7782 18.1914ZM22.4242 28.4155H13.5524C12.83 28.4155 12.2558 27.8228 12.2558 27.1189C12.2558 26.4151 12.83 25.8224 13.5524 25.8224H22.4242C23.1465 25.8224 23.7207 26.4151 23.7207 27.1189C23.7207 27.8413 23.1465 28.4155 22.4242 28.4155Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector_2",
			d: "M33.8575 12.2177C33.9272 12.9268 33.158 13.4016 32.4823 13.1754C31.5473 12.8624 30.5633 12.7059 29.5399 12.7059H6.46185C5.43047 12.7059 4.41502 12.8728 3.46752 13.1911C2.79999 13.4153 2.03516 12.9561 2.03516 12.2519V8.63113C2.03516 2.01887 4.05403 0 10.6663 0H12.8519C15.5004 0 16.3339 0.852 17.4082 2.24113L19.6308 5.20461C20.0938 5.83435 20.1124 5.87139 20.9273 5.87139H25.3355C31.1248 5.87139 33.3869 7.42211 33.8575 12.2177Z",
			fill: "currentColor"
		})]
	})
});
export default SvgOrganisationProjects;
